/**
 * @file Identity Name component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getIdentityLastName, getIdentityName } from '../../../util/identity';
import { IDENTITY_RELATIONSHIP } from '../../../constants/identity';

class IdentityName extends Component {
  static propTypes = {
    identity: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      relationship: PropTypes.oneOf(Object.values(IDENTITY_RELATIONSHIP)),
    }),
    user: PropTypes.shape({
      name: PropTypes.string,
    }),
    className: PropTypes.string,
    loading: PropTypes.bool,
    displayLastName: PropTypes.bool,
    defaultName: PropTypes.string,
  };

  render() {
    const { className, loading, identity, user, displayLastName, defaultName } =
      this.props;

    if (defaultName && identity?.name === 'Me') {
      return <span className={className}>{defaultName}</span>;
    }

    return !loading ? (
      <span className={className}>
        {getIdentityName(identity, user)}
        {displayLastName && ` ${getIdentityLastName(identity)}`}
      </span>
    ) : (
      ''
    );
  }
}

export default IdentityName;
